/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes, { string } from "prop-types"
import { useStaticQuery, graphql, navigate } from "gatsby"

import Header from "./header/header"
import "../styles/main.scss"
import Footer from "./footer/footer"
import PlainFooter from "./footer/footer-plain"

// Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DialogContentPlaceholder, dialog } from "./popup-dialog";
import config from '../configs/ad/popup';
import { env } from "../configs/env";
import { TrackingService } from "../core/services/TrackingService";
import { CMSDataProvider } from "../cms/CMSDataProvider"
import date from "../core/utils/date"
import { Dayjs } from "dayjs"
import { usePopupDialogs } from "../cms/hooks/usePopupDialogs"

type Props = {
    children: any,
    removeNav?: boolean,
    removeFooter?: boolean,
    requirePassword?: string | null,
    launchDate?: string | Date | Dayjs | null,
    endDate?: string | Date | Dayjs | null,
    endHref?: string,
    skipEndDate?: boolean,
}

const Layout = ({ children, removeNav, removeFooter, requirePassword, launchDate, endDate, endHref, skipEndDate }: Props) => {
    const data = useStaticQuery(graphql`
        query SiteTitleQuery {
            site {
                siteMetadata {
                    title
                }
            }
        }
    `)

    const { getDisplayDialog } = usePopupDialogs();

    const [isAllowedAccess, setIsAllowedAccess] = React.useState(
        requirePassword === undefined
    )

    React.useEffect(() => {
        const launchDT = date.hktime(launchDate);
        const endDT = date.hktime(endDate);

        if ((env.mode === 'production' && requirePassword && !isAllowedAccess) || (env.mode === 'production' && launchDT && launchDT.isAfter(date.today()))) {
            const pwd = prompt(`此頁面${launchDT ? `將於${launchDT.format("YYYY/MM/DD")}上線` : '仍未上線'}, 如為測試人員, 請輸入密碼`);
            if (pwd !== (requirePassword ?? 'test')) {
                window.location.href = env.url.web;
            } else {
                setIsAllowedAccess(true);
            }
        }

        if (!skipEndDate && endDT && date.today().isAfter(endDT, 'day')) {
            const params = new URLSearchParams(location.search);
            if (!params.has(`skipEndDate`)) {
                if (endHref) {
                    navigate(endHref);
                } else {
                    alert(`此活動已於${endDT.format("YYYY/MM/DD")}完結，多謝支持。`);
                    window.location.href = env.url.web;
                }
            }
        }
    }, []);

    React.useLayoutEffect(() => {
        const isUnderDevelopment = true;
        if (env.mode === "production" || isUnderDevelopment) {
            if (!window.location.pathname.includes("self-test")
                && !window.location.pathname.includes("doctors/hpv")
                && !window.location.pathname.includes("hksh")
                && !window.location.pathname.includes("indicaidcare")
                && !window.location.pathname.includes("meadjohnson")
            ) {
                const d = getDisplayDialog();
                if (!!d) {
                    dialog(
                        "body",
                        `popup-ad`,
                        new DialogContentPlaceholder({
                            eventName: d.slug,
                            imgSrc: d.image,
                            href: d.href,
                            openInNewTab: true,
                            width: `${d.width}px`,
                            height: `${d.height}px`,
                            marginTop: `${d.marginTop}vh`,
                        }),
                        d.coolDownInHours * 3600,
                        isUnderDevelopment,
                    );
                }
            }
        }
    }, []);

    return (
        <CMSDataProvider>
            {!removeNav && (
                <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
            )}
            <ToastContainer></ToastContainer>
            {children}
            {!removeFooter && <Footer />}
            {removeNav && !removeFooter && <PlainFooter />}
        </CMSDataProvider>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    removeNav: PropTypes.bool,
}

export default Layout
